import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg
    width="119"
    height="119"
    viewBox="0 0 119 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_23253_56482)">
      <path
        d="M57.2543 108.703C84.4558 108.703 106.509 86.6501 106.509 59.3514C106.509 32.0527 84.3587 10 57.2543 10C30.0527 10 8 32.0527 8 59.3514C8 86.6501 30.0527 108.703 57.2543 108.703Z"
        fill="#F5F6FA"
      />
      <g filter="url(#filter0_dd_23253_56482)">
        <path
          d="M71.5332 33.1207L86.3969 86.5523C86.8826 88.3982 85.814 90.244 83.9682 90.7297L31.6052 104.622C29.7593 105.108 27.9135 104.039 27.4278 102.193L9.16387 33.2179C8.67813 31.372 9.74676 29.5262 11.5926 29.0405L49.4805 19.0342L71.5332 33.1207Z"
          fill="white"
        />
      </g>
      <path
        d="M70.7601 66.9283L42.4899 74.4087L39.3811 75.1859L29.9577 77.7118C29.5691 77.8089 29.2777 78.2947 29.472 78.7804C29.5691 79.2661 30.0549 79.5576 30.4435 79.4604L39.8669 76.9346L42.9756 76.1574L71.2458 68.677C71.6344 68.5798 71.9259 68.0941 71.7316 67.6083C71.6344 67.1226 71.1487 66.8311 70.7601 66.9283Z"
        fill="#C7CAD6"
      />
      <path
        d="M68.9095 60.3227L58.4175 63.0429L54.823 64.0144L28.3015 71.1062C27.9129 71.2033 27.6215 71.6891 27.8158 72.1748C27.9129 72.6606 28.3986 72.952 28.7872 72.8549L55.4059 65.763L59.0004 64.7915L69.4924 62.0714C69.881 61.9742 70.1725 61.4885 69.9782 61.0028C69.7839 60.6142 69.2981 60.2256 68.9095 60.3227Z"
        fill="#C7CAD6"
      />
      <path
        d="M67.3533 53.6189L64.6332 54.299L61.913 54.979L26.4538 64.4024C26.0652 64.4996 25.7738 64.9853 25.9681 65.471C26.0652 65.9568 26.551 66.2482 26.9396 66.1511L62.3988 56.7277L65.4104 55.9505L67.8391 55.2705C68.2277 55.1733 68.5191 54.6876 68.3248 54.2018C68.2277 53.8132 67.8391 53.5218 67.3533 53.6189Z"
        fill="#C7CAD6"
      />
      <path
        d="M50.9353 88.0095L48.9923 88.4952C48.6037 88.5924 48.118 88.3009 48.0209 87.8152C47.9237 87.3294 48.118 86.8437 48.5066 86.7465L50.4496 86.2608C50.8382 86.1637 51.3239 86.4551 51.421 86.9408C51.5182 87.5237 51.3239 87.9123 50.9353 88.0095Z"
        fill="#C7CAD6"
      />
      <path
        d="M45.016 89.5642L33.8439 92.4786C33.4553 92.5758 32.9696 92.2843 32.8724 91.7986C32.7753 91.3128 32.9696 90.8271 33.3582 90.7299L44.5302 87.8155C44.9188 87.7183 45.4046 88.0098 45.5017 88.4955C45.696 88.9813 45.5017 89.467 45.016 89.5642Z"
        fill="#C7CAD6"
      />
      <path
        d="M65.9963 46.9165L57.1558 49.248L55.0186 49.8309L24.8054 57.7971C24.4168 57.8942 24.1254 58.38 24.3197 58.8657C24.4168 59.3515 24.9025 59.6429 25.2911 59.5458L55.4072 51.6767L57.5444 51.0939L66.2878 48.7623C66.7735 48.6651 66.9678 48.1794 66.8707 47.5965C66.8707 47.2079 66.3849 46.8193 65.9963 46.9165Z"
        fill="#C7CAD6"
      />
      <path
        d="M45.1077 32.2464L20.0434 38.8525C19.4605 39.0468 18.8777 38.6582 18.6834 38.0753C18.4891 37.4924 18.8777 36.9095 19.4605 36.7152L44.5248 30.1091C45.1077 29.9148 45.6906 30.3034 45.8849 30.8863C46.0792 31.4692 45.6906 32.0521 45.1077 32.2464Z"
        fill="#C7CAD6"
      />
      <path
        d="M31.3135 42.3499L21.6958 44.8758C21.1129 45.0701 20.53 44.6815 20.3357 44.0986C20.1414 43.5157 20.53 42.9328 21.1129 42.7385L30.6334 40.2127C31.2163 40.0184 31.7992 40.4069 31.9935 40.9898C32.1878 41.5727 31.7992 42.1556 31.3135 42.3499Z"
        fill="#C7CAD6"
      />
      <path
        d="M49.4805 19.0342L53.3664 33.8007C53.9493 35.8409 56.1837 37.1038 58.2238 36.5209L71.5332 33.1207"
        fill="#C7CAD6"
      />
      <g filter="url(#filter1_dd_23253_56482)">
        <path
          d="M110.783 48.1789L101.845 102.971C101.554 104.816 99.7079 106.079 97.8621 105.691L44.6247 96.3645C42.7789 96.0731 41.516 94.2273 41.8074 92.3814L54.1453 22.1431C54.4367 20.2973 56.2826 19.0344 58.1284 19.423L96.7935 26.2234L110.783 48.1789Z"
          fill="white"
        />
      </g>
      <path
        d="M95.9185 78.5863L67.1626 73.5346L64.0538 72.9517L54.4361 71.3001C54.0475 71.203 53.5618 71.5916 53.5618 72.0773C53.4646 72.5631 53.7561 73.0488 54.1447 73.146L63.7624 74.7975L66.8711 75.3804L95.6271 80.4321C96.0157 80.5292 96.5014 80.1407 96.5014 79.6549C96.5986 79.1692 96.4043 78.6834 95.9185 78.5863Z"
        fill="#C7CAD6"
      />
      <path
        d="M97.087 71.8832L86.4007 70.0373L82.8062 69.3573L55.7018 64.597C55.3132 64.4999 54.8274 64.8885 54.8274 65.3742C54.7303 65.8599 55.0217 66.3457 55.4103 66.4428L82.5147 71.2031L86.1092 71.8832L96.7955 73.729C97.1841 73.8261 97.6699 73.4375 97.6699 72.9518C97.767 72.466 97.4756 71.9803 97.087 71.8832Z"
        fill="#C7CAD6"
      />
      <path
        d="M98.4443 65.0833L95.627 64.5976L92.8097 64.1119L56.6705 57.7972C56.2819 57.7001 55.7962 58.0887 55.7962 58.5744C55.699 59.0601 55.9905 59.5459 56.3791 59.643L92.5183 65.9577L95.627 66.5406L98.0557 66.9292C98.4443 67.0263 98.9301 66.6377 98.9301 66.152C99.1244 65.6662 98.9301 65.1805 98.4443 65.0833Z"
        fill="#C7CAD6"
      />
      <path
        d="M69.1072 89.4667L67.1642 89.1753C66.7756 89.0781 66.4842 88.5924 66.5813 88.1066C66.6785 87.6209 67.0671 87.2323 67.4557 87.3294L69.3986 87.6209C69.7872 87.718 70.0787 88.2038 69.9815 88.6895C69.8844 89.2724 69.4958 89.4667 69.1072 89.4667Z"
        fill="#C7CAD6"
      />
      <path
        d="M63.1829 88.3985L51.8166 86.4555C51.428 86.3584 51.1365 85.8726 51.2337 85.3869C51.3308 84.9012 51.7194 84.5126 52.108 84.6097L63.4744 86.5527C63.863 86.6498 64.1544 87.1356 64.0573 87.6213C63.9601 88.2042 63.5715 88.4957 63.1829 88.3985Z"
        fill="#C7CAD6"
      />
      <path
        d="M99.9975 58.4769L90.9627 56.9225L88.7283 56.5339L57.9322 51.0936C57.5436 50.9965 57.0579 51.385 57.0579 51.8708C56.9607 52.3565 57.2522 52.8423 57.6408 52.9394L88.4368 58.3797L90.6712 58.7683L99.6089 60.3227C100.095 60.4198 100.483 60.0313 100.58 59.5455C100.678 59.0598 100.386 58.574 99.9975 58.4769Z"
        fill="#C7CAD6"
      />
      <path
        d="M87.2752 36.4247L61.7252 31.9559C61.1423 31.8587 60.7537 31.2758 60.8508 30.6929C60.948 30.11 61.5309 29.7214 62.1137 29.8186L87.6638 34.2874C88.2467 34.3846 88.6353 34.9675 88.5381 35.5503C88.441 36.0361 87.8581 36.5218 87.2752 36.4247Z"
        fill="#C7CAD6"
      />
      <path
        d="M70.4668 39.727L60.6548 37.9783C60.0719 37.8812 59.6834 37.2983 59.7805 36.7154C59.8777 36.1325 60.4605 35.7439 61.0434 35.841L70.7583 37.5897C71.3412 37.6869 71.7298 38.2698 71.6326 38.8526C71.5355 39.4355 70.9526 39.8241 70.4668 39.727Z"
        fill="#C7CAD6"
      />
      <path
        d="M96.6984 26.2236L94.0754 41.2816C93.6868 43.4189 95.2411 45.459 97.3784 45.8476L110.785 48.1792"
        fill="#C7CAD6"
      />
      <path
        d="M75.372 94.0008C86.1097 94.0008 94.8143 85.2962 94.8143 74.5585C94.8143 63.8208 86.1097 55.1162 75.372 55.1162C64.6343 55.1162 55.9297 63.8208 55.9297 74.5585C55.9297 85.2962 64.6343 94.0008 75.372 94.0008Z"
        fill="white"
      />
      <path
        d="M73.4752 77.2933C73.3882 76.9455 73.3882 76.5976 73.3882 76.1628C73.3882 74.6845 73.997 73.38 75.5623 72.2495L76.8667 71.2929C77.6494 70.6842 77.9973 69.9885 77.9973 69.1188C77.9973 67.9014 77.1276 66.6839 75.3014 66.6839C73.3882 66.6839 72.5186 68.2492 72.5186 69.7276C72.5186 70.0754 72.5186 70.3363 72.6056 70.5972L69.127 70.5102C69.0401 70.1624 68.9531 69.7276 68.9531 69.2928C68.9531 66.336 71.1272 63.5532 75.2144 63.5532C79.3887 63.5532 81.6497 66.2491 81.6497 68.9449C81.6497 71.119 80.5192 72.5973 78.9538 73.7279L77.8233 74.5105C76.8667 75.2062 76.345 76.0759 76.345 77.1194V77.2933H73.4752ZM74.9536 79.0326C76.171 79.0326 77.1276 79.9892 77.1276 81.2067C77.1276 82.4241 76.171 83.3807 74.9536 83.3807C73.7361 83.3807 72.7795 82.4241 72.7795 81.2067C72.8665 80.0761 73.7361 79.0326 74.9536 79.0326Z"
        fill="#C7CAD6"
      />
      <path
        d="M103.913 104.234C103.168 104.234 102.424 103.933 101.829 103.256L89.3994 90.6941L88.9528 90.995C84.9337 94.0038 80.2448 95.5835 75.4814 95.5835C69.7505 95.5835 64.0196 93.2516 59.7772 89.1897C55.3116 84.9022 52.8555 79.1102 52.8555 72.7917C52.8555 60.2299 62.9776 50 75.407 50C83.8917 50 91.3345 54.5132 95.3536 62.1857C99.2982 69.7829 98.7772 78.6589 93.9394 85.8048L93.6417 86.2561L106.146 98.8932C107.411 100.172 107.113 101.451 106.89 102.128C106.294 103.331 105.104 104.234 103.913 104.234ZM75.407 56.2433C66.3268 56.2433 59.033 63.6901 59.033 72.7917C59.033 83.1721 67.4433 89.4154 75.6303 89.4154C80.6169 89.4154 85.157 87.1588 88.3574 83.0969C92.302 78.1324 92.9719 71.4378 90.2181 65.6458C87.3898 59.8539 81.7333 56.2433 75.407 56.2433Z"
        fill="#C7CAD6"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_23253_56482"
        x="0.046875"
        y="14.0342"
        width="95.4688"
        height="103.705"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_23253_56482" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_23253_56482"
          result="effect2_dropShadow_23253_56482"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_23253_56482"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_23253_56482"
        x="32.7656"
        y="14.3525"
        width="87.0156"
        height="104.409"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_23253_56482" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_23253_56482"
          result="effect2_dropShadow_23253_56482"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_23253_56482"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_23253_56482">
        <rect width="119" height="119" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const EmptyFileIcon = (props) => <Icon component={svg} {...props} />;

export default EmptyFileIcon;
